export interface AICostEvent {
  id: string;
  timestamp: string;
  model: string;
  feature: string;
  inputTokens: number;
  outputTokens: number;
  estimatedCostUsd: number;
  latencyMs: number;
  success: boolean;
}

export const MOCK_COST_EVENTS: AICostEvent[] = [
  {
    id: 'cost-1',
    timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    model: 'gemini-2.5-flash',
    feature: 'Global Search Intent Resolver',
    inputTokens: 420,
    outputTokens: 85,
    estimatedCostUsd: 0.00012,
    latencyMs: 240,
    success: true,
  },
  {
    id: 'cost-2',
    timestamp: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    model: 'gemini-2.5-flash',
    feature: 'Assistant Explanation Generation',
    inputTokens: 1250,
    outputTokens: 310,
    estimatedCostUsd: 0.00045,
    latencyMs: 580,
    success: true,
  },
  {
    id: 'cost-3',
    timestamp: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    model: 'gemini-2.5-flash',
    feature: 'RAG Synthesis & Grounding',
    inputTokens: 2400,
    outputTokens: 450,
    estimatedCostUsd: 0.00085,
    latencyMs: 720,
    success: true,
  },
];

export function calculateTotalCost(events: AICostEvent[]): number {
  return events.reduce((acc, ev) => acc + ev.estimatedCostUsd, 0);
}
